import React from 'react';
import { Gender } from '../../../utils/apiClient';
import { Field } from './FormPage';
import { ChipGroup } from './ChipGroup';
import { DateField } from './DateField';

export interface PersonFieldsValue {
  lastName: string;
  firstName: string;
  patronymic?: string;
  birthDate?: Date;
  city: string;
  gender?: Gender;
}

interface PersonFieldsProps {
  /** Префикс для id полей (чтобы на странице не было дублей) */
  idPrefix: string;
  value: PersonFieldsValue;
  onChange: (patch: Partial<PersonFieldsValue>) => void;
  /** Дополнительное поле в строке «дата рождения — город» (например, email при регистрации) */
  extraField?: React.ReactNode;
  genderHint?: React.ReactNode;
}

const GENDER_OPTIONS = [
  { value: Gender.Male, label: 'Мужской' },
  { value: Gender.Female, label: 'Женский' },
];

/**
 * Общий блок «Кто это»: ФИО, дата рождения, город, пол.
 * Используется в регистрации, редактировании профиля и создании участника, чтобы формы выглядели одинаково.
 */
export const PersonFields: React.FC<PersonFieldsProps> = ({ idPrefix, value, onChange, extraField, genderHint }) => (
  <>
    <div className="form-page__row">
      <Field label="Фамилия" htmlFor={`${idPrefix}-lastName`}>
        <input
          id={`${idPrefix}-lastName`}
          className="form-page__input"
          type="text"
          value={value.lastName}
          onChange={(e) => onChange({ lastName: e.target.value })}
          autoComplete="family-name"
          placeholder="Иванов"
          required
        />
      </Field>
      <Field label="Имя" htmlFor={`${idPrefix}-firstName`}>
        <input
          id={`${idPrefix}-firstName`}
          className="form-page__input"
          type="text"
          value={value.firstName}
          onChange={(e) => onChange({ firstName: e.target.value })}
          autoComplete="given-name"
          placeholder="Иван"
          required
        />
      </Field>
      <Field label="Отчество" htmlFor={`${idPrefix}-patronymic`} optional>
        <input
          id={`${idPrefix}-patronymic`}
          className="form-page__input"
          type="text"
          value={value.patronymic ?? ''}
          onChange={(e) => onChange({ patronymic: e.target.value })}
          autoComplete="additional-name"
          placeholder="Иванович"
        />
      </Field>
    </div>

    <div className={`form-page__row${extraField ? '' : ' form-page__row--two'}`}>
      <DateField
        label="Дата рождения"
        value={value.birthDate}
        onChange={(birthDate) => onChange({ birthDate })}
      />
      <Field label="Город" htmlFor={`${idPrefix}-city`}>
        <input
          id={`${idPrefix}-city`}
          className="form-page__input"
          type="text"
          value={value.city}
          onChange={(e) => onChange({ city: e.target.value })}
          autoComplete="address-level2"
          placeholder="Москва"
          required
        />
      </Field>
      {extraField}
    </div>

    <ChipGroup
      label="Пол"
      type="radio"
      name={`${idPrefix}-gender`}
      compact
      options={GENDER_OPTIONS}
      selected={value.gender ? [value.gender] : []}
      onToggle={(v) => onChange({ gender: v as Gender })}
      hint={genderHint ?? 'Нужен для подбора категории на соревнованиях'}
    />
  </>
);
